import React, { useMemo } from 'react';

import { Hero, HeroProps } from './Hero';

interface HeroProductProps extends HeroProps {
  product: string;
  productImg: string;
}

const HeroProduct = ({
  className,
  product,
  productImg,
  ...props
}: HeroProductProps) => {
  const containerClass = useMemo(
    () =>
      className
        ? [classNames.container, className].join(' ')
        : classNames.container,
    [className],
  );

  return (
    <div className={containerClass}>
      <div className={classNames.productLogo}>
        <img src={productImg} height={34} width={34} />
        <h3 className="tw-button">
          {product}
          <sup>&trade;</sup>
        </h3>
      </div>
      <Hero {...props} />
    </div>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-flex-col',
    'tw-gap-[32px]',
    'md:tw-gap-[40px]',
    'xl:tw-max-w-[1128px]',
  ].join(' '),
  productLogo: [
    'tw-flex',
    'tw-flex-row',
    'tw-self-center',
    'lg:tw-self-start',
    'tw-items-center',
    'tw-gap-[12px]',
  ].join(' '),
};

export { HeroProduct };
export type { HeroProductProps };
